import { Earth } from './crs-earth';
import { LonLat } from './projection/projection-lonlat';
import { Transformation } from './transformation/transformation';
/*
 * @namespace CRS
 * @crs L.CRS.EPSG4326
 *
 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
 *
 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
 */
export class EPSG4326 extends Earth {
    constructor() {
        super(...arguments);
        this.code = 'EPSG:4326';
        this.projection = new LonLat();
        this.transformation = new Transformation(1 / 180, 1, -1 / 180, 0.5);
    }
}
